import {createBarbaPage} from '../baseBarbaPage';
import qs from "query-string";

export default  createBarbaPage({
    namespace: 'frontpage',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
        let sreenWidth = $( window ).width();
        let swooshPosition = $('.first-swoosh').position()
        let lengthToMove = swooshPosition.left - (sreenWidth / 2) +50

        anime({
            easing: 'easeInOutQuad',
            duration: 1000,
            targets: '.first-swoosh',
            translateX: [- lengthToMove,0],

        });
        anime({
            easing: 'easeInOutQuad',
            duration: 1000,
            targets: '.second-swoosh',
            translateX: [+ lengthToMove, 0],

        });
        anime({
            easing: 'easeInOutQuad',
            duration: 1000,
            targets: '.front-page-header-content',
            scale: [0, 1],
            opacity: [0,1]

        });


        new Waypoint({
            element: document.getElementById('waypoint-one'),
            offset: '90%',
            handler: function(direction) {
                console.log('waypoint fired')
                var svgTL = anime.timeline({
                    easing: 'easeInCubic',
                    duration: 750
                });

                svgTL
                    .add({
                        targets: '#Green_Circle_-_P circle',
                        strokeDashoffset: [anime.setDashoffset, 1],
                        duration: 1000,
                    })
                    .add({
                        targets: '#Check_Mark_-_P ',
                        opacity: [0, 1],
                        easing: 'easeInCirc',
                        duration: 100,
                    })
                    .add({
                        targets: '#Purchasing_Text text',
                        fill: '#D9E046',
                        duration: 100,
                    }, '-=100')
                    .add({
                        targets: '#Green_Circle_-_R circle',
                        strokeDashoffset: [anime.setDashoffset, 1],
                        duration: 1000,
                    })
                    .add({
                        targets: '#Check_Mark_-_R',
                        opacity: [0, 1],
                        easing: 'easeInCirc',
                        duration: 100,
                    })
                    .add({
                        targets: '#Reduce_Text_1_ tspan',
                        fill: '#D9E046',
                        duration: 100,
                    }, '-=100')
                    .add({
                        targets: '#Green_Circle_-_C circle',
                        strokeDashoffset: [anime.setDashoffset, 1],
                        duration: 1000,
                    })
                    .add({
                        targets: '#Check_Mark_-_C',
                        opacity: [0, 1],
                        easing: 'easeInCirc',
                        duration: 100,
                    })
                    .add({
                        targets: '#Cleaning_Text tspan',
                        fill: '#D9E046',
                        duration: 100,
                    }, '-=100')
            }
        })

         new Waypoint({
            element: document.getElementById('waypoint-two'),
            offset: '90%',
            handler: function(direction) {
                anime({
                    targets: '.front-we-can-help-circle',
                    scale: [0, 1],
                    easing: 'easeOutElastic',
                    duration: 1000,
                    delay: anime.stagger(300)
                })
            }
        })







        // anime({
        //     targets: '.front-we-can-help-circle',
        //     scale: [0, 1],
        //     duration: 1000,
        //     easing: 'easeOutBounce'
        // })

        $('#frontPartSearch').submit((ev) => {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            const searchVal = $('.front__search-box').val();
            let queryMap = qs.parse(location.search);
            queryMap['q'] = searchVal;
            queryMap.state = 'search';
            const url = `/design-center/?${qs.stringify(queryMap)}`;
            Barba.Pjax.goTo(url);
        });
    },
    onEnterCompleted: function() {
        // The Transition has just finished.

    },
    onLeave: function() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});


// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!
